{
  "GenericScopeTab_CME": "CME",
  "GenericScopeTab_Telsys": "Telefonieserver",
  "GenericScopeTab_Telsys_Required": "Telefonieserver is vereist",
  "GenericScopeTab_Partition": "Partitie",
  "GenericScopeTab_Device": "Apparaat",
  "GenericScopeTab_FilterRecursive": "Recursief filteren",
  "NAME": "GenericScopeTab"
}